var map = {
	"./Certifications.js": "e711",
	"./Charges.js": "42ac",
	"./Config.js": "34cd",
	"./Doctors.js": "e3ed",
	"./Patient.js": "b3bb",
	"./Payments.js": "bd34",
	"./Reports.js": "8a30",
	"./Services.js": "3fb2",
	"./Users.js": "00db",
	"./index.js": "2a74"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d307";